<!-- AddBlockModal.vue -->
<template>
  <div class="modal fade add-block-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-uppercase" id="myLargeModalLabel">Add A Block</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <p class="text-capitalize">
                Please input the new block details below. If a block with a similar name is already registered, a table will be displayed. It is recommended to use unique block names to ensure accurate data presentation.
              </p>
              <div>
                <label class="form-label text-uppercase">Enter Block Name/Number Below</label>
                <input v-model="blockName" class="form-control" type="text" placeholder="Enter Block Number">
              </div>

              <div class="mt-3">
                <table class="table align-middle table-nowrap table-hover dt-responsive contacts-table dataTable no-footer table-sm" id="datatable-buttons">
                  <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th scope="col">Block Name</th>
                    <th scope="col">Subcounty</th>
                    <th scope="col">Ward</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" :value="item" v-for="(item, index) in blocks">
                    <td>{{index+1}}.</td>
                    <td class="text-uppercase">{{item.block}}</td>
                    <td>{{item.subCountyName}}</td>
                    <td>{{item.wardName}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="">Sub County</label>
                    <select class="form-select font-13px" @change="handleSubCountyChange" v-model="selectedSubCounty">
                      <option v-for="(item, index) in subCounties" :key="`${index}`" :value="item">{{item.subCountyName}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-group">
                    <label for="">Ward</label>
                    <select class="form-select font-13px" v-model="selectedWard">
                      <option :key="`${index}`" :value="item" v-for="(item, index) in wards">{{item.wardName}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a @click="handleSubmit" type="button" class="btn btn-primary waves-effect waves-light">
            <i class="bx bx-check font-size-16 align-middle me-2"></i> Submit
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddBlockModal',
  props: {
    blocks: {
      type: Array,
      default: () => []
    },
    subCounties: {
      type: Array,
      default: () => []
    },
    wards: {
      type: Array,
      default: () => []
    }
  },
  emits: ['submit', 'get-wards'],
  data() {
    return {
      blockName: '',
      selectedSubCounty: null,
      selectedWard: null
    }
  },
  methods: {
    handleSubCountyChange() {
      this.$emit('get-wards', this.selectedSubCounty.subCountyID);
    },
    handleSubmit() {
      if (!this.blockName.trim()) {
        alert('Please enter a block name');
        return;
      }

      if (!this.selectedSubCounty) {
        alert('Please select a sub county');
        return;
      }

      if (!this.selectedWard) {
        alert('Please select a ward');
        return;
      }

      this.$emit('submit', {
        block: this.blockName,
        subCounty: this.selectedSubCounty,
        ward: this.selectedWard
      });

      // Reset form
      this.blockName = '';
      this.selectedSubCounty = null;
      this.selectedWard = null;
    }
  }
}
</script>